<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">step 3 | Choose your stencil material</div>

    <b-form-radio-group id="radioMaterial"
                        name="radioMaterial"
                        class="mt-4"
                        :checked="material"
                        :value="material"
                        @change="changeMaterial">

      <b-form-radio v-for="option in materials" :key="option.text" :value="option.value" :disabled="!option.available">
        <span v-html="option.text"></span>
      </b-form-radio>

    </b-form-radio-group>

    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      materials: 'product/materials',
      material: 'product/material'
    })
  },
  methods: {
    changeMaterial(newMaterial) {
      this.$store.commit('product/setMaterial', newMaterial)
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 2)

      this.$store.dispatch('product/SET_ACTIVETAB', 2)
      this.$store.dispatch('product/SET_ACTIVETAB', 3)
    }
  }
}
</script>
